module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "ack01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('h2', {
    staticClass: "chaptertitle"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" would like to express my gratitude to all the clients over the years who have helped me gain an understanding of the all-encompassing interplay between the cosmos and the individual. I thank the students at my courses and lectures—particularly the students of AstrologSkolen—who over a seven-year period of experiential play so enriched my knowledge of astrology. No words can express my appreciation of my own teacher, Tarab Tulku, without whom I may never have discovered how empowering the right view can be.")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-738ac4a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 69
// module chunks = 0